import { render, staticRenderFns } from "./FileUploaderTransparent2.vue?vue&type=template&id=fe4ff086&scoped=true"
import script from "./FileUploaderTransparent2.vue?vue&type=script&lang=js"
export * from "./FileUploaderTransparent2.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderTransparent2.vue?vue&type=style&index=0&id=fe4ff086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4ff086",
  null
  
)

export default component.exports